import React from "react";
import { Panel } from "../components/Panel";
import { IOSToggle } from "../../../components/IOSToggle";
import { Action } from "../hooks/useHabitState";

interface FeaturesSettingsSectionProps {
  greyOutEnabled: boolean;
  contextsEnabled: boolean;
  notesEnabled: boolean;
  categoriesEnabled: boolean;
  heatmapEnabled: boolean;
  sortOrder: "alphabetical" | "score";
  onToggleGreyOut: (value: boolean) => void;
  onToggleContexts: (value: boolean) => void;
  onToggleNotes: (value: boolean) => void;
  onToggleCategories: (value: boolean) => void;
  onToggleHeatmap: (value: boolean) => void;
  onSortOrderChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const FeaturesSettingsSection: React.FC<
  FeaturesSettingsSectionProps
> = ({
  greyOutEnabled,
  contextsEnabled,
  notesEnabled,
  categoriesEnabled,
  heatmapEnabled,
  sortOrder,
  onToggleGreyOut,
  onToggleContexts,
  onToggleNotes,
  onToggleCategories,
  onToggleHeatmap,
  onSortOrderChange,
}) => {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Panel
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontWeight: 500, marginBottom: "4px" }}>
              Grey Out Inactive Habits
            </div>
            <div style={{ fontSize: "0.85em", color: "rgba(0, 0, 0, 0.6)" }}>
              Automatically reduce opacity of habits that haven't been used
              recently
            </div>
          </div>
          <IOSToggle isOn={greyOutEnabled} onChange={onToggleGreyOut} />
        </Panel>

        <Panel
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontWeight: 500, marginBottom: "4px" }}>
              Enable Contexts
            </div>
            <div style={{ fontSize: "0.85em", color: "rgba(0, 0, 0, 0.6)" }}>
              Show context section in daily view
            </div>
          </div>
          <IOSToggle isOn={contextsEnabled} onChange={onToggleContexts} />
        </Panel>

        <Panel
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontWeight: 500, marginBottom: "4px" }}>
              Enable Daily Notes
            </div>
            <div style={{ fontSize: "0.85em", color: "rgba(0, 0, 0, 0.6)" }}>
              Show notes section in daily view
            </div>
          </div>
          <IOSToggle
            isOn={notesEnabled}
            onChange={onToggleNotes}
            data-testid="notes-toggle"
          />
        </Panel>

        <Panel
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontWeight: 500, marginBottom: "4px" }}>
              Enable Categories
            </div>
            <div style={{ fontSize: "0.85em", color: "rgba(0, 0, 0, 0.6)" }}>
              Show categories section in daily view
            </div>
          </div>
          <IOSToggle
            isOn={categoriesEnabled}
            onChange={onToggleCategories}
            data-testid="categories-toggle"
          />
        </Panel>

        <Panel
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontWeight: 500, marginBottom: "4px" }}>
              Show Heatmap in Report
            </div>
            <div style={{ fontSize: "0.85em", color: "rgba(0, 0, 0, 0.6)" }}>
              Display visual heatmap timeline in monthly report view
            </div>
          </div>
          <IOSToggle
            isOn={heatmapEnabled}
            onChange={onToggleHeatmap}
            data-testid="heatmap-toggle"
          />
        </Panel>

        <div
          style={{
            padding: "12px 16px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            border: "0.5px solid #ccc",
          }}
        >
          <div style={{ fontWeight: 500, marginBottom: "8px" }}>Sort Order</div>
          <select
            value={sortOrder}
            onChange={onSortOrderChange}
            style={{
              width: "100%",
              padding: "12px 16px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              color: "#000",
              fontSize: "16px",
              appearance: "none",
              backgroundImage:
                "url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 12px center",
              backgroundSize: "12px auto",
              paddingRight: "30px",
            }}
          >
            <option value="alphabetical">Alphabetical</option>
            <option value="score">By Score</option>
          </select>
        </div>
      </div>
    );
  };
